import FormattedMessage from 'I18n/components/FormattedMessage';
import { getButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import CurrentPlanTag from '../common/badges/CurrentPlanTag';
import { SuiteFeatures } from './features-display/SuiteFeatures';
import { MerchCardLayoutUIGridRowStart } from './merch-card-layout-ui/MerchCardLayoutUIGridRowStart';
import HighlightedFreePriceDisplay from './price-display/HighlightedFreePriceDisplay';
import { MicroCopy } from './price-display/PriceStyledComponents';

/*
 * Only ever used on public pages on the starter tab
 * Therefore there is no pre-seats version of this
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HighlightedFreeCard = ({
  productLine,
  columnStart
}) => {
  const isAppReady = useGlobalLoading();
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: FREE
  }));
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const Title = /*#__PURE__*/_jsxs(_Fragment, {
    children: [isCurrentPlanLevel && /*#__PURE__*/_jsx(CurrentPlanTag, {}), /*#__PURE__*/_jsx(SectionTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.freeCard.title"
      })
    })]
  });
  const CTAs = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [47],
    widths: ['100%'],
    children: /*#__PURE__*/_jsx(SignupButton, Object.assign({
      sourceId: "pricing-hero",
      productLine: productLine,
      use: "primary",
      nonMerchandiseIdProduct: "crm",
      trackingSource: FREE_CARD
    }, ctaVariantProps))
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUIGridRowStart, {
    "data-test-id": `${productLine}-free-card`,
    "data-selenium-id": `${productLine}-free-card`,
    columnStart: columnStart,
    Title: Title,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: HighlightedProductsHeaderConfig[productLine][FREE].subtitle
    }),
    Pricing: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {}),
    Subtext: /*#__PURE__*/_jsx(MicroCopy, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing.subtexts.free.current"
      })
    }),
    CTAs: CTAs,
    Features: /*#__PURE__*/_jsx(SuiteFeatures, {
      productLevel: FREE,
      loading: !isAppReady
    })
  });
};